<!--
 * @Descripttion: 大屏设置
 * @Author: zenghua.wang
 * @Date: 2021-04-19 16:04:45
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-17 11:19:56
-->
<template>
  <div class="widget-screen">
    <el-form label-position="left" label-suffix="：" label-width="100px" size="small" :model="data" :rules="rules">
      <el-form-item label="大屏名称" prop="reportName">
        <el-input v-model="data.reportName" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="关键字" prop="reportKey">
        <el-input v-model="data.reportKey" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="大屏宽度">
        <el-input-number style="width: 100%" v-model="data.screenWidth" clearable placeholder="请输入">
        </el-input-number>
      </el-form-item>
      <el-form-item label="大屏高度">
        <el-input-number style="width: 100%" v-model="data.screenHeight" clearable placeholder="请输入">
        </el-input-number>
      </el-form-item>
      <el-form-item label="大屏简介">
        <el-input v-model="data.screenNote" type="textarea" :rows="2" clearable placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="data.backgroundColor" :predefine="predefineColors"></el-color-picker>
      </el-form-item>
      <el-form-item label="背景图片">
        <el-upload class="widget-screen-bg" accept="image/*" :show-file-list="false" :limit="1"
          :http-request="onHttpRequest" ref="screenUploader">
          <img v-if="data.backgroundImage" :src="data.backgroundImage" style="width: 100%" />
          <i v-else class="el-icon-plus"></i>
        </el-upload>
        <div class="xa-form-tips">备注：尺寸为{{data.screenWidth}}px x {{data.screenHeight}}px</div>
      </el-form-item>

      <el-form-item label="权限方式">
        <el-select v-model="data.authType" clearable placeholder="请选择" style="width:100%">
          <el-option v-for="item in authTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="角色选择">
        <vue-multiple-select :multiple-list="data.roleList" @multipleOpen="show=true" />

        <RoleSelect :visible.sync="show" :multiple="true" :backDatas="data.roleList" @onChecked="handleChecked" />
      </el-form-item>

      <el-form-item label="无权限链接">
        <el-input type="textarea" rows="2" v-model="data.redirect" clearable placeholder="请输入无权限跳转地址"></el-input>
      </el-form-item>

      <div class="widget-version">当前版本：v{{version}}</div>
    </el-form>

    <!-- 背景图片 -->
    <!-- <el-dialog
      title="图库"
      :visible.sync="showUpload"
      append-to-body
      width="70%"
      class="picture-dialog"
    >
      <el-upload accept="image/*" :limit="1" :show-file-list="false">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <div class="picture-list">
        <div
          class="picture-list-item"
          v-for="(item, index) in pictureList"
          :key="index"
          @click="setBackgroundImage(item.url)"
        >
          <img :src="item.url" />
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import apiUpload from '@/dragComponents/mixins/apiUpload'
import { component, predefineColors } from '@/dragComponents/model/default.js'

import vueMultipleSelect from '@/dragComponents/components/vueMultipleSelect'
import { RoleSelect } from '@/framework/components/user'
const sVersion = require('@/dataScreen/package.json').version

export default {
  name: 'widget-screen',
  components: {
    vueMultipleSelect,
    RoleSelect
  },
  mixins: [apiUpload],
  props: ['data'],
  data() {
    return {
      authTypeList: component.authType,
      predefineColors: predefineColors,
      show: false,
      version: sVersion,
      // showUpload: false,
      // pictureList: [
      //   {
      //     url: require("@/dragComponents/public/images/bg/bg1.png"),
      //   },
      //   {
      //     url: require("@/dragComponents/public/images/bg/bg2.jpeg"),
      //   },
      // ],
      rules: {
        reportName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        reportKey: [
          { required: true, message: '请输入关键字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // showUploadDialog() {
    //   this.showUpload = true;
    // },
    // setBackgroundImage(url) {
    //   this.data.backgroundImage = url;
    //   this.showUpload = false;
    // },
    onHttpRequest(file) {
      this.apiUploadPicture(file, (path) => {
        this.data.backgroundImage = path
        this.$refs.screenUploader.uploadFiles = []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/dragComponents/styles/variables.scss";

.widget {
  &-screen {
    padding: 10px;

    &-bg {
      height: 100px;
      line-height: 100px;
      border: 1px dashed #ddd;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      :deep(.el-upload) {
        width: 100%;
        height: 100%;
      }

      :deep(.el-icon-plus) {
        font-size: 28px;
        color: #8c939d;
      }

      img {
        width: 100%;
      }
    }
  }

  &-version {
    text-align: center;
    font-size: 12px;
    color: #cfcccc;
  }
}

.picture {
  &-dialog {
    :deep(.el-dialog__body) {
      padding-top: 10px;
    }
  }

  &-list {
    margin-top: 20px;
    height: 260px;
    @include scrollable();
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &-item {
      width: 23%;
      min-height: 100px;
      max-height: 120px;
      overflow: hidden;
      margin-right: 20px;
      margin-bottom: 20px;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      img {
        width: 100%;
      }
    }
  }
}
</style>
